import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=636c612e"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports